import {
  LitheElement,
  LitheFC,
  LitheSpecificElement,
} from '@wheelbox/lithejs-engine';

export interface SectionHeadingProps {
  id?: string;
  testId?: string;
  title: string;
  subtitle?: string;
  align?: 'left' | 'center' | 'right';
  class?: string;
}

const SectionHeading: LitheFC<SectionHeadingProps> = ({
  id = 'section-heading',
  testId = 'section-heading',
  title,
  subtitle,
  align = 'center',
  class: className = '',
}): LitheElement<'div'> => {
  const alignmentClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
  };

  const children: LitheSpecificElement[] = [
    [
      'h2',
      {
        class: 'text-3xl md:text-4xl font-bold text-primary mb-4',
      },
      title,
    ],
  ];

  if (subtitle) {
    children.push([
      'p',
      {
        class: 'text-lg text-muted-foreground max-w-2xl mx-auto',
      },
      subtitle,
    ]);
  }

  return [
    'div',
    {
      id,
      'data-testid': testId,
      class: `mb-12 ${alignmentClasses[align]} ${className}`,
    },
    ...children,
  ];
};

export default SectionHeading;
